import axios from 'axios';
import apiConfig from '../../api.config';

export default async function sendOptOut(hotelId, atlasID, product, IHClientId) {
  const {
    host,
    URIs: { hbxOptOut },
  } = apiConfig;

  const data = {
    hotelId,
    atlasID,
    product,
    IHClientId,
  };

  const uri = `${host}${hbxOptOut}`;

  return await axios.post(uri, data).then(res => res.data);
}
